<template>
  <div class="install-box">
    <Header :config="headConfig" />
    <SelectStore @selectApp="selectStore" />
    <van-cell title="App" is-link :value="appName?appName:'Choose Your App'" @click="selectCoutry" />
    <SelectCountry />
  </div>
</template>
  
<script>
export default {
  name: 'KeepRanking',
  setup(){
     
  } 
}
</script>
  
<style scoped lang="scss">
.install-box {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  background-color: #f6f5ff;
}
</style>